import Repository from "./Repository";

const BASE_KNOWLEDGE = "/ai-support/admin/knowledge";
const BASE_SETTINGS = "/ai-support/admin/settings";
const BASE_FEEDBACK = "/ai-support/admin/feedback";
const BASE_AUDIT = "/ai-support/admin/audit";
const BASE_CLIENT_SESSIONS = "/ai-support/sessions";

const ChatbotKnowledgeRepository = {
  getArticles({ category = "", status = "", search = "", page = 1, limit = 10 } = {}) {
    const params = {};
    if (category) params.category = category;
    if (status) params.status = status;
    if (search) params.search = search;
    if (page) params.page = page;
    if (limit) params.limit = limit;

    return Repository.get(BASE_KNOWLEDGE, { params });
  },

  getArticle(id) {
    return Repository.get(`${BASE_KNOWLEDGE}/${id}`);
  },

  createArticle(payload) {
    return Repository.post(BASE_KNOWLEDGE, payload);
  },

  updateArticle(id, payload) {
    return Repository.put(`${BASE_KNOWLEDGE}/${id}`, payload);
  },

  deleteArticle(id) {
    return Repository.delete(`${BASE_KNOWLEDGE}/${id}`);
  },

  getSettings() {
    return Repository.get(BASE_SETTINGS);
  },

  updateSettings(payload) {
    return Repository.put(BASE_SETTINGS, payload);
  },

  getFeedbackSummary({ days = 30 } = {}) {
    return Repository.get(BASE_FEEDBACK, { params: { days } });
  },

  getAuditLogs({ event = "feedback", session = "", page = 1, limit = 50 } = {}) {
    const params = { event, page, limit };
    if (session) params.session = session;
    return Repository.get(BASE_AUDIT, { params });
  },

  submitMessageFeedback(sessionId, messageId, feedback) {
    return Repository.post(
      `${BASE_CLIENT_SESSIONS}/${sessionId}/messages/${messageId}/feedback`,
      { feedback }
    );
  },
};

export default ChatbotKnowledgeRepository;
